module.exports = __webpack_public_path__ + "img/vip6.beda4241.png";